import { Component, Input } from '@angular/core';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'recrewt-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
  standalone: false,
})
export class InfoBoxComponent {
  @Input() type: ThemePalette = 'primary';

  @Input() text = '';
}
